// @ts-nocheck
import React, { useEffect, useRef, useState } from 'react';

export default function CommitInput({
  value,
  onCommit,
  onPaste,
  className,
  style,
  ariaLabel,
  disabled,
}: {
  value: string;
  onCommit?: ((raw: string) => void) | null;
  onPaste?: ((e: React.ClipboardEvent<HTMLInputElement>) => void) | null;
  className?: string;
  style?: React.CSSProperties;
  ariaLabel?: string;
  disabled?: boolean;
}) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(value == null ? '' : String(value));
  const skipCommit = useRef(false);
  const initial = useRef('');

  useEffect(() => {
    if (!editing) setDraft(value == null ? '' : String(value));
  }, [value, editing]);

  return (
    <input
      className={className}
      value={editing ? draft : (value == null ? '' : String(value))}
      onFocus={() => {
        skipCommit.current = false;
        initial.current = value == null ? '' : String(value);
        setEditing(true);
        setDraft(initial.current);
      }}
      onChange={(e) => setDraft(e.target.value)}
      onBlur={() => {
        setEditing(false);
        if (skipCommit.current) {
          skipCommit.current = false;
          setDraft(value == null ? '' : String(value));
          return;
        }
        if (draft.trim() === initial.current.trim()) return;
        if (typeof onCommit === 'function') onCommit(draft);
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          (e.target as HTMLInputElement).blur();
        } else if (e.key === 'Escape') {
          e.preventDefault();
          skipCommit.current = true;
          (e.target as HTMLInputElement).blur();
        }
      }}
      onPaste={onPaste || undefined}
      aria-label={ariaLabel}
      disabled={disabled}
      style={style}
    />
  );
}
